import React from 'react';
import { cn } from '@/lib/utils';

interface LoaderProps {
  size?: 'sm' | 'md' | 'lg'
  text?: string
  className?: string
  textClassName?: string
}

const Loader = ({
    size = 'md',
    text,
    className,
    textClassName
}: LoaderProps) => {
    // Size mappings
    const sizeClasses = {
        sm: 'h-5 w-5',
        md: 'h-8 w-8',
        lg: 'h-12 w-12'
    };

    const textSizeClasses = {
        sm: 'text-xs pt-2',
        md: 'text-sm pt-2',
        lg: 'text-base pt-3'
    };

    return (
        <div className={cn(
            'flex flex-col items-center justify-center text-center',
            className
        )}>
            {/* Container for both spinner and text */}
            <div className="relative flex flex-col items-center">
                {/* Spinner container with fixed dimensions */}
                <div className={cn('relative', sizeClasses[size])}>
                    {/* Outer circle - slow rotation */}
                    <div className={cn(
                        'absolute inset-0 rounded-full border-2 border-t-indigo-500 border-r-indigo-400 border-b-indigo-300 border-l-indigo-200',
                        'animate-spin [animation-duration:1.5s]'
                    )} />

                    {/* Inner circle - faster rotation */}
                    <div className={cn(
                        'absolute inset-1 rounded-full border-2 border-t-purple-500 border-r-transparent border-b-purple-300 border-l-transparent',
                        'animate-spin [animation-duration:1s] [animation-direction:reverse]'
                    )} />
                </div>

                {/* Text placed underneath */}
                {text && (
                    <p className={cn(
                        'font-medium text-gray-500 w-full',
                        textSizeClasses[size],
                        textClassName
                    )}>
                        {text}
                    </p>
                )}
            </div>
        </div>
    );
};

export default Loader;
